import { __ } from '@wordpress/i18n';
import AnalyticsTable from './AnalyticsTable';

/**
 * Detailed Analytics Component - Contains tables for country and browser data
 * @param {Object} statsData - Statistics data object
 */
const DetailedAnalytics = ({ statsData }) => {
  return (
    <div className="hvnly-detailed-analytics">
      <AnalyticsTable 
        title={__('Visitors by Country', 'havenlytics')} 
        data={statsData.countryData} 
        columns={[
          { key: 'country', header: __('Country', 'havenlytics'), render: (item, index) => (
            <>
              <span 
                className="hvnly-country-flag"
                style={{ backgroundColor: `hsl(${index * 60}, 70%, 45%)` }}
              ></span>
              {item.country}
            </>
          )},
          { key: 'visitors', header: __('Visitors', 'havenlytics'), render: (item) => item.visitors.toLocaleString() },
          { key: 'percentage', header: __('Percentage', 'havenlytics'), render: (item) => `${item.percentage}%` }
        ]} 
      />
      
      <AnalyticsTable 
        title={__('Browser Usage', 'havenlytics')} 
        data={statsData.browserData} 
        columns={[
          { key: 'browser', header: __('Browser', 'havenlytics'), render: (item) => (
            <>
              <i className={`fab fa-${item.browser.toLowerCase()} ${item.browser.toLowerCase() === 'chrome' ? 'fa-chrome' : item.browser.toLowerCase() === 'firefox' ? 'fa-firefox' : item.browser.toLowerCase() === 'safari' ? 'fa-safari' : item.browser.toLowerCase() === 'edge' ? 'fa-edge' : 'fa-globe'}`}></i>
              {item.browser}
            </>
          )},
          { key: 'users', header: __('Users', 'havenlytics'), render: (item) => item.users.toLocaleString() },
          { key: 'percentage', header: __('Percentage', 'havenlytics'), render: (item) => `${item.percentage}%` }
        ]} 
      />
    </div>
  );
};

export default DetailedAnalytics;